import { useQuery } from "@tanstack/react-query";

import { getFarmSettings } from "services";

import { useUserContext } from "utils";

import { GET_FARM_SETTINGS } from "consts";

import { FarmSettings } from "models";

export const useGetFarmSettings = () => {
  const { user } = useUserContext();

  return useQuery<FarmSettings[]>({
    queryKey: [GET_FARM_SETTINGS, user?.farm.id],
    queryFn: getFarmSettings,
    enabled: !!user && !!user.farm.id,
  });
};
